import { GET, GET_DOWNLOAD } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/batch-failed-record${endpoint}`;
};

export const getAllFailedBatchRecords = (token, page = 0, pageSize = 25) => {
  const endpoint = getEndpointWithPrefix(`?page=${page}&pageSize=${pageSize}`);
  return GET(endpoint, token);
};

export const searchFailedBatchRecords = (token, { batchId, type, fileName, accountId, page = 0, pageSize = 25 }) => {
  const params = new URLSearchParams({ page, pageSize });
  if (batchId) params.append('batchId', batchId);
  if (type) params.append('type', type);
  if (fileName) params.append('fileName', fileName);
  if (accountId) params.append('accountId', accountId);

  const endpoint = getEndpointWithPrefix(`/search?${params.toString()}`);
  return GET(endpoint, token);
};

export const downloadFailedBatchRecords = (token, { batchId, type, fileName, accountId, page = 0, pageSize = 25 } = {}) => {
  const params = new URLSearchParams({ page, pageSize });
  if (batchId) params.append('batchId', batchId);
  if (type) params.append('type', type);
  if (fileName) params.append('fileName', fileName);
  if (accountId) params.append('accountId', accountId);

  const endpoint = getEndpointWithPrefix(`/search/download?${params.toString()}`);
  return GET_DOWNLOAD(endpoint, token);
};
